var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.extensionItem)?_c('Card',{key:_vm.compKey},[_c('SubHeader',{attrs:{"title":_vm.extensionItem.name}}),_c('p',[_vm._v(_vm._s(_vm.extensionItem.description))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }